/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {PlotTemperature} from '../bioplanModels';
// @ts-ignore
import type {Temperature} from '../bioplanModels';
// @ts-ignore
import type {WriteAutomaticTemperatureModel} from '../bioplanModels';
// @ts-ignore
import type {WriteInterpolateTemperatureModel} from '../bioplanModels';
// @ts-ignore
import type {WriteStepTemperatureModel} from '../bioplanModels';
/**
 * ModellingTemperatureApi - axios parameter creator
 * @export
 */
export const ModellingTemperatureApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get temperature model for site
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureAutomaticEntityIdGet: async (
      entityId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('temperatureAutomaticEntityIdGet', 'entityId', entityId);
      const localVarPath = `/temperature/automatic/{entityId}`.replace(
        `{${'entityId'}}`,
        encodeURIComponent(String(entityId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Set temperature model for site
     * @param {string} entityId
     * @param {WriteAutomaticTemperatureModel} writeAutomaticTemperatureModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureAutomaticEntityIdPost: async (
      entityId: string,
      writeAutomaticTemperatureModel: WriteAutomaticTemperatureModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('temperatureAutomaticEntityIdPost', 'entityId', entityId);
      // verify required parameter 'writeAutomaticTemperatureModel' is not null or undefined
      assertParamExists(
        'temperatureAutomaticEntityIdPost',
        'writeAutomaticTemperatureModel',
        writeAutomaticTemperatureModel,
      );
      const localVarPath = `/temperature/automatic/{entityId}`.replace(
        `{${'entityId'}}`,
        encodeURIComponent(String(entityId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        writeAutomaticTemperatureModel,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get temperature model for site or cage
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureGet: async (
      cageId?: string,
      siteId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/temperature/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get interpolate temperature model for site
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureInterpolateEntityIdGet: async (
      entityId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('temperatureInterpolateEntityIdGet', 'entityId', entityId);
      const localVarPath = `/temperature/interpolate/{entityId}`.replace(
        `{${'entityId'}}`,
        encodeURIComponent(String(entityId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Set interpolate temperature model for entity
     * @param {string} entityId
     * @param {WriteInterpolateTemperatureModel} writeInterpolateTemperatureModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureInterpolateEntityIdPost: async (
      entityId: string,
      writeInterpolateTemperatureModel: WriteInterpolateTemperatureModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('temperatureInterpolateEntityIdPost', 'entityId', entityId);
      // verify required parameter 'writeInterpolateTemperatureModel' is not null or undefined
      assertParamExists(
        'temperatureInterpolateEntityIdPost',
        'writeInterpolateTemperatureModel',
        writeInterpolateTemperatureModel,
      );
      const localVarPath = `/temperature/interpolate/{entityId}`.replace(
        `{${'entityId'}}`,
        encodeURIComponent(String(entityId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        writeInterpolateTemperatureModel,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get predicted sea surface temperature
     * @param {string} fromDate
     * @param {number} numberOfDays
     * @param {number} longitude
     * @param {number} latitude
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperaturePredictGet: async (
      fromDate: string,
      numberOfDays: number,
      longitude: number,
      latitude: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fromDate' is not null or undefined
      assertParamExists('temperaturePredictGet', 'fromDate', fromDate);
      // verify required parameter 'numberOfDays' is not null or undefined
      assertParamExists('temperaturePredictGet', 'numberOfDays', numberOfDays);
      // verify required parameter 'longitude' is not null or undefined
      assertParamExists('temperaturePredictGet', 'longitude', longitude);
      // verify required parameter 'latitude' is not null or undefined
      assertParamExists('temperaturePredictGet', 'latitude', latitude);
      const localVarPath = `/temperature/predict`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (fromDate !== undefined) {
        localVarQueryParameter['fromDate'] =
          (fromDate as any) instanceof Date ? (fromDate as any).toISOString().substring(0, 10) : fromDate;
      }

      if (numberOfDays !== undefined) {
        localVarQueryParameter['numberOfDays'] = numberOfDays;
      }

      if (longitude !== undefined) {
        localVarQueryParameter['longitude'] = longitude;
      }

      if (latitude !== undefined) {
        localVarQueryParameter['latitude'] = latitude;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get temperature model for site
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureStepEntityIdGet: async (entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('temperatureStepEntityIdGet', 'entityId', entityId);
      const localVarPath = `/temperature/step/{entityId}`.replace(
        `{${'entityId'}}`,
        encodeURIComponent(String(entityId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Set step temperature model for entity
     * @param {string} entityId
     * @param {WriteStepTemperatureModel} writeStepTemperatureModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureStepEntityIdPost: async (
      entityId: string,
      writeStepTemperatureModel: WriteStepTemperatureModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('temperatureStepEntityIdPost', 'entityId', entityId);
      // verify required parameter 'writeStepTemperatureModel' is not null or undefined
      assertParamExists('temperatureStepEntityIdPost', 'writeStepTemperatureModel', writeStepTemperatureModel);
      const localVarPath = `/temperature/step/{entityId}`.replace(
        `{${'entityId'}}`,
        encodeURIComponent(String(entityId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        writeStepTemperatureModel,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModellingTemperatureApi - functional programming interface
 * @export
 */
export const ModellingTemperatureApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ModellingTemperatureApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get temperature model for site
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperatureAutomaticEntityIdGet(
      entityId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Temperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperatureAutomaticEntityIdGet(entityId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperatureAutomaticEntityIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Set temperature model for site
     * @param {string} entityId
     * @param {WriteAutomaticTemperatureModel} writeAutomaticTemperatureModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperatureAutomaticEntityIdPost(
      entityId: string,
      writeAutomaticTemperatureModel: WriteAutomaticTemperatureModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Temperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperatureAutomaticEntityIdPost(
        entityId,
        writeAutomaticTemperatureModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperatureAutomaticEntityIdPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get temperature model for site or cage
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperatureGet(
      cageId?: string,
      siteId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Temperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperatureGet(cageId, siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperatureGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get interpolate temperature model for site
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperatureInterpolateEntityIdGet(
      entityId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Temperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperatureInterpolateEntityIdGet(entityId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperatureInterpolateEntityIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Set interpolate temperature model for entity
     * @param {string} entityId
     * @param {WriteInterpolateTemperatureModel} writeInterpolateTemperatureModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperatureInterpolateEntityIdPost(
      entityId: string,
      writeInterpolateTemperatureModel: WriteInterpolateTemperatureModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Temperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperatureInterpolateEntityIdPost(
        entityId,
        writeInterpolateTemperatureModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperatureInterpolateEntityIdPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get predicted sea surface temperature
     * @param {string} fromDate
     * @param {number} numberOfDays
     * @param {number} longitude
     * @param {number} latitude
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperaturePredictGet(
      fromDate: string,
      numberOfDays: number,
      longitude: number,
      latitude: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlotTemperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperaturePredictGet(
        fromDate,
        numberOfDays,
        longitude,
        latitude,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperaturePredictGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get temperature model for site
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperatureStepEntityIdGet(
      entityId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Temperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperatureStepEntityIdGet(entityId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperatureStepEntityIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Set step temperature model for entity
     * @param {string} entityId
     * @param {WriteStepTemperatureModel} writeStepTemperatureModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async temperatureStepEntityIdPost(
      entityId: string,
      writeStepTemperatureModel: WriteStepTemperatureModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Temperature>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.temperatureStepEntityIdPost(
        entityId,
        writeStepTemperatureModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingTemperatureApi.temperatureStepEntityIdPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ModellingTemperatureApi - factory interface
 * @export
 */
export const ModellingTemperatureApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ModellingTemperatureApiFp(configuration);
  return {
    /**
     *
     * @summary Get temperature model for site
     * @param {ModellingTemperatureApiTemperatureAutomaticEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureAutomaticEntityIdGet(
      requestParameters: ModellingTemperatureApiTemperatureAutomaticEntityIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Temperature> {
      return localVarFp
        .temperatureAutomaticEntityIdGet(requestParameters.entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Set temperature model for site
     * @param {ModellingTemperatureApiTemperatureAutomaticEntityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureAutomaticEntityIdPost(
      requestParameters: ModellingTemperatureApiTemperatureAutomaticEntityIdPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Temperature> {
      return localVarFp
        .temperatureAutomaticEntityIdPost(
          requestParameters.entityId,
          requestParameters.writeAutomaticTemperatureModel,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get temperature model for site or cage
     * @param {ModellingTemperatureApiTemperatureGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureGet(
      requestParameters: ModellingTemperatureApiTemperatureGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Temperature> {
      return localVarFp
        .temperatureGet(requestParameters.cageId, requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get interpolate temperature model for site
     * @param {ModellingTemperatureApiTemperatureInterpolateEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureInterpolateEntityIdGet(
      requestParameters: ModellingTemperatureApiTemperatureInterpolateEntityIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Temperature> {
      return localVarFp
        .temperatureInterpolateEntityIdGet(requestParameters.entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Set interpolate temperature model for entity
     * @param {ModellingTemperatureApiTemperatureInterpolateEntityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureInterpolateEntityIdPost(
      requestParameters: ModellingTemperatureApiTemperatureInterpolateEntityIdPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Temperature> {
      return localVarFp
        .temperatureInterpolateEntityIdPost(
          requestParameters.entityId,
          requestParameters.writeInterpolateTemperatureModel,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get predicted sea surface temperature
     * @param {ModellingTemperatureApiTemperaturePredictGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperaturePredictGet(
      requestParameters: ModellingTemperatureApiTemperaturePredictGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PlotTemperature> {
      return localVarFp
        .temperaturePredictGet(
          requestParameters.fromDate,
          requestParameters.numberOfDays,
          requestParameters.longitude,
          requestParameters.latitude,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get temperature model for site
     * @param {ModellingTemperatureApiTemperatureStepEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureStepEntityIdGet(
      requestParameters: ModellingTemperatureApiTemperatureStepEntityIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Temperature> {
      return localVarFp
        .temperatureStepEntityIdGet(requestParameters.entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Set step temperature model for entity
     * @param {ModellingTemperatureApiTemperatureStepEntityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    temperatureStepEntityIdPost(
      requestParameters: ModellingTemperatureApiTemperatureStepEntityIdPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Temperature> {
      return localVarFp
        .temperatureStepEntityIdPost(requestParameters.entityId, requestParameters.writeStepTemperatureModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for temperatureAutomaticEntityIdGet operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperatureAutomaticEntityIdGetRequest
 */
export interface ModellingTemperatureApiTemperatureAutomaticEntityIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureAutomaticEntityIdGet
   */
  readonly entityId: string;
}

/**
 * Request parameters for temperatureAutomaticEntityIdPost operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperatureAutomaticEntityIdPostRequest
 */
export interface ModellingTemperatureApiTemperatureAutomaticEntityIdPostRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureAutomaticEntityIdPost
   */
  readonly entityId: string;

  /**
   *
   * @type {WriteAutomaticTemperatureModel}
   * @memberof ModellingTemperatureApiTemperatureAutomaticEntityIdPost
   */
  readonly writeAutomaticTemperatureModel: WriteAutomaticTemperatureModel;
}

/**
 * Request parameters for temperatureGet operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperatureGetRequest
 */
export interface ModellingTemperatureApiTemperatureGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureGet
   */
  readonly cageId?: string;

  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureGet
   */
  readonly siteId?: string;
}

/**
 * Request parameters for temperatureInterpolateEntityIdGet operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperatureInterpolateEntityIdGetRequest
 */
export interface ModellingTemperatureApiTemperatureInterpolateEntityIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureInterpolateEntityIdGet
   */
  readonly entityId: string;
}

/**
 * Request parameters for temperatureInterpolateEntityIdPost operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperatureInterpolateEntityIdPostRequest
 */
export interface ModellingTemperatureApiTemperatureInterpolateEntityIdPostRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureInterpolateEntityIdPost
   */
  readonly entityId: string;

  /**
   *
   * @type {WriteInterpolateTemperatureModel}
   * @memberof ModellingTemperatureApiTemperatureInterpolateEntityIdPost
   */
  readonly writeInterpolateTemperatureModel: WriteInterpolateTemperatureModel;
}

/**
 * Request parameters for temperaturePredictGet operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperaturePredictGetRequest
 */
export interface ModellingTemperatureApiTemperaturePredictGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperaturePredictGet
   */
  readonly fromDate: string;

  /**
   *
   * @type {number}
   * @memberof ModellingTemperatureApiTemperaturePredictGet
   */
  readonly numberOfDays: number;

  /**
   *
   * @type {number}
   * @memberof ModellingTemperatureApiTemperaturePredictGet
   */
  readonly longitude: number;

  /**
   *
   * @type {number}
   * @memberof ModellingTemperatureApiTemperaturePredictGet
   */
  readonly latitude: number;
}

/**
 * Request parameters for temperatureStepEntityIdGet operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperatureStepEntityIdGetRequest
 */
export interface ModellingTemperatureApiTemperatureStepEntityIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureStepEntityIdGet
   */
  readonly entityId: string;
}

/**
 * Request parameters for temperatureStepEntityIdPost operation in ModellingTemperatureApi.
 * @export
 * @interface ModellingTemperatureApiTemperatureStepEntityIdPostRequest
 */
export interface ModellingTemperatureApiTemperatureStepEntityIdPostRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingTemperatureApiTemperatureStepEntityIdPost
   */
  readonly entityId: string;

  /**
   *
   * @type {WriteStepTemperatureModel}
   * @memberof ModellingTemperatureApiTemperatureStepEntityIdPost
   */
  readonly writeStepTemperatureModel: WriteStepTemperatureModel;
}

/**
 * ModellingTemperatureApi - object-oriented interface
 * @export
 * @class ModellingTemperatureApi
 * @extends {BaseAPI}
 */
export class ModellingTemperatureApi extends BaseAPI {
  /**
   *
   * @summary Get temperature model for site
   * @param {ModellingTemperatureApiTemperatureAutomaticEntityIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperatureAutomaticEntityIdGet(
    requestParameters: ModellingTemperatureApiTemperatureAutomaticEntityIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperatureAutomaticEntityIdGet(requestParameters.entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Set temperature model for site
   * @param {ModellingTemperatureApiTemperatureAutomaticEntityIdPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperatureAutomaticEntityIdPost(
    requestParameters: ModellingTemperatureApiTemperatureAutomaticEntityIdPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperatureAutomaticEntityIdPost(
        requestParameters.entityId,
        requestParameters.writeAutomaticTemperatureModel,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get temperature model for site or cage
   * @param {ModellingTemperatureApiTemperatureGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperatureGet(
    requestParameters: ModellingTemperatureApiTemperatureGetRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperatureGet(requestParameters.cageId, requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get interpolate temperature model for site
   * @param {ModellingTemperatureApiTemperatureInterpolateEntityIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperatureInterpolateEntityIdGet(
    requestParameters: ModellingTemperatureApiTemperatureInterpolateEntityIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperatureInterpolateEntityIdGet(requestParameters.entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Set interpolate temperature model for entity
   * @param {ModellingTemperatureApiTemperatureInterpolateEntityIdPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperatureInterpolateEntityIdPost(
    requestParameters: ModellingTemperatureApiTemperatureInterpolateEntityIdPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperatureInterpolateEntityIdPost(
        requestParameters.entityId,
        requestParameters.writeInterpolateTemperatureModel,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get predicted sea surface temperature
   * @param {ModellingTemperatureApiTemperaturePredictGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperaturePredictGet(
    requestParameters: ModellingTemperatureApiTemperaturePredictGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperaturePredictGet(
        requestParameters.fromDate,
        requestParameters.numberOfDays,
        requestParameters.longitude,
        requestParameters.latitude,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get temperature model for site
   * @param {ModellingTemperatureApiTemperatureStepEntityIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperatureStepEntityIdGet(
    requestParameters: ModellingTemperatureApiTemperatureStepEntityIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperatureStepEntityIdGet(requestParameters.entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Set step temperature model for entity
   * @param {ModellingTemperatureApiTemperatureStepEntityIdPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingTemperatureApi
   */
  public temperatureStepEntityIdPost(
    requestParameters: ModellingTemperatureApiTemperatureStepEntityIdPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingTemperatureApiFp(this.configuration)
      .temperatureStepEntityIdPost(requestParameters.entityId, requestParameters.writeStepTemperatureModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
